import React, { useEffect, useState } from 'react';

import { cssMap } from '@compiled/react';

import { Box, Stack } from '@atlaskit/primitives/compiled';

import { parseDynamicLayoutOutputToJson } from './dynamic-layout-parser/dynamic-layout-parser';
import type { SectionElement } from './dynamic-layout-parser/types/dynamic-layout-section';
import { DynamicLayoutSections } from './ui/section/dynamic-layout-sections';

export type DynamicLayoutData = {
	data: string;
	fastAnswerData?: string;
};

interface DynamicLayoutBodyProps {
	contentToRender: string;
}

const styles = cssMap({
	containerStyles: {
		textAlign: 'left',
	},
});

export const DynamicLayout = ({ contentToRender }: DynamicLayoutBodyProps): React.JSX.Element => {
	const [parsedAnswer, setParsedData] = useState<SectionElement[]>();

	useEffect(() => {
		if (contentToRender) {
			const res = parseDynamicLayoutOutputToJson(contentToRender);
			if (res && res.length > 0) {
				setParsedData(res);
			}
		}
	}, [contentToRender]);

	return (
		<Box xcss={styles.containerStyles} testId="dynamic-layout-container">
			<Stack space="space.300">
				{parsedAnswer &&
					parsedAnswer.length &&
					parsedAnswer.map((section, index) => (
						<DynamicLayoutSections key={index} section={section} />
					))}
			</Stack>
		</Box>
	);
};
